/**
 * Utility helper for quickly checking if Contentful Preview has been enabled
 * via environment variables.
 *
 * @todo Should this be a simple boolean check, or should there be a helper to just
 *       return the appropriate access token? - Ryan
 *
 * @return {boolean}
 */
export const isContentfulPreview = () => {
  return !!process.env.CONTENTFUL_PREVIEW && process.env.CONTENTFUL_PREVIEW === 'true';
};